import { EtatEcriture } from './../index';
import { FournisseurType } from '../fournisseurs.enum';

export class ItemAccount {
  IdTiersSignataire: string;
  RaisonSocialeSignataire: string;
  IdTiersFacture: string;
  RaisonSocialeFacture: string;
  RaisonSocialePayeur: string;
  IdTiersPayeur: string;
  DocumentNumber: string;
  CodeLettrageEcriture: string;
  LibellePiece: string;
  DateEmission: Date;
  DateEcheance: Date;
  Montant: number;
  Solde: number;
  SupplierId: number;
  TypePiece: TypePiece;
  UrlPdf: string;
  AccountingDocumentId: number;
  BillId: number;
  State: EtatEcriture;
  IsInshoppingCart: boolean;
  CodeTypeMarquage: string;
  PanierActif: boolean = false;

  get isDateEcheanceExpired(): boolean {
    const dateNow: Date = new Date();
    return this.TypePiece === TypePiece.FACTURE && this.Solde !== 0 && this.DateEcheance < dateNow;
  }

  get isEligible(): boolean {
    if (this.Solde === 0 ||
      (this.State === EtatEcriture.REGLEE && this.Solde !== 0) ||
      this.State === EtatEcriture.EN_COURS_DE_REGLEMENT ||
      this.CodeTypeMarquage === ListMarquageFacture.factRj ||
      this.CodeTypeMarquage === ListMarquageFacture.factEtalee) {
      return false;
    } else {
      return true;
    }
  }

  get DocumentStatus(): string {
    if (this.TypePiece === TypePiece.AVOIR) {
      return '';
    } else if (this.TypePiece === TypePiece.FACTURE) {
      if (this.CodeTypeMarquage === ListMarquageFacture.factRj) {
        return 'En redressement';
      }
      if (this.CodeTypeMarquage === ListMarquageFacture.factEtalee) {
        return 'Etalement';
      }
      if (this.State === EtatEcriture.PRELEVEMENT_DEMANDE) {
        return 'Prélèvement à\u00A0venir';
      }
      if (this.State === EtatEcriture.EN_COURS_DE_PRELEVEMENT) {
        return 'Prélèvement en\u00A0cours';
      }
      if (this.State === EtatEcriture.EN_COURS_DE_REGLEMENT ||
        (this.State === EtatEcriture.REGLEE && this.Solde !== 0)
      ) {
        return 'En traitement';
      }
      if (this.Solde === 0) {
        return 'Réglée';
      } else {
        const dateNow: Date = new Date();
        if (this.DateEcheance < dateNow) {
          return 'En retard';
        } else {
          return 'A régler';
        }
      }
    }
  }
}

export enum TypePiece {
  FACTURE = 1,
  AVOIR,
}

export const TypePieceAsStrings: { [key in TypePiece]: string } = {
  [TypePiece.FACTURE]: 'Facture',
  [TypePiece.AVOIR]: 'Avoir',
};

export enum ListMarquageFacture {
  factRj = 'RJ',
  factEtalee = 'ETL'
}
